import { render, staticRenderFns } from "./DynamicFormDashboard.vue?vue&type=template&id=b800bbca&scoped=true&"
import script from "./DynamicFormDashboard.vue?vue&type=script&lang=js&"
export * from "./DynamicFormDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormDashboard.vue?vue&type=style&index=0&id=b800bbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b800bbca",
  null
  
)

export default component.exports